import LatinoTemplateDefault from 'src/components/template/la'
import { leagueIds, sportIds } from 'src/constants'
import { laChannelCount, laDiscountPriceMonthly } from 'src/constants/planData/latinoPlanData'
import React from 'react'

export default (props) => {
  return (
    <LatinoTemplateDefault
      location={props.location}
      lang="es"
      market="latino"
      posterMobile="https://assets-imgx.fubo.tv/marketing/lp/images/posters/Colombian_PrimeraA_LP_Mobile.jpg"
      poster="https://assets-imgx.fubo.tv/marketing/lp/images/posters/Colombian_PrimeraA_LP_Web.jpg"
      title="Mira la Liga BetPlay Dimayor sin cable"
      subtitle={
        <>
          Obtén más de {laChannelCount}+ canales de TV en vivo y deportes <br /> en español por solo
          ${laDiscountPriceMonthly} el primer mes
        </>
      }
      networkSet="soccerLatino"
      noteLink="/la/liga-betplay-dimayor/"
      sportId={sportIds.Soccer}
      leagueId={leagueIds['Liga BetPlay Dimayor']}
      additionalFAQs={additionalFAQs}
      matchtickerSportId={sportIds.Soccer}
      matchtickerLeagueName="Liga BetPlay Dimayor"
      matchtickerLeagueId={leagueIds['Liga BetPlay Dimayor']}
      laPromoImg="https://assets-imgx.fubo.tv/marketing/lp/images/card/latino/latino-leagues-card.png"
    />
  )
}

const additionalFAQs = [
  {
    question: '¿Puedo ver fútbol colombiano en Fubo?',
    answer:
      'Sí, puedes ver todo el fútbol colombiano en Fubo, incluyendo partidos de la Liga BetPlay Dimayor (Categoría Primera A). Los partidos están disponibles en Fubo Latino Network.',
  },
  {
    question: '¿Cómo puedo encontrar los partidos de la Liga BetPlay Dimayor en Fubo?',
    answer:
      'Para encontrar los partidos de la Liga BetPlay Dimayor en Fubo, simplemente ve a la sección de deportes y busca la programación de eventos en vivo. También puedes usar la función de búsqueda para encontrar rápidamente partidos específicos.',
  },
  {
    question:
      '¿Fubo ofrece cobertura en vivo del Independiente de Santa Fe, Atlético Nacional y otros equipos importantes de la Liga BetPlay Dimayor?',
    answer:
      'Sí, Fubo ofrece cobertura en vivo de los mejores equipos de la Categoría Primera A, incluyendo Independiente Santa Fe, Atlético Nacional y otros. Sintoniza Fubo Latino Network para ver la acción en tiempo real.',
  },
  {
    question: '¿Puedo ver comentarios y análisis de la Liga BetPlay Dimayor en Fubo?',
    answer:
      '¡Por supuesto! Fubo ofrece comentarios y análisis de los partidos de la Liga BetPlay Dimayor, lo que mejora tu experiencia visual. Consulta la programación para ver programas específicos relacionados con el fútbol colombiano.',
  },
  {
    question: '¿Puedo ver los resúmenes de la Liga BetPlay Dimayor en Fubo?',
    answer:
      'Sí, puedes ver los resúmenes de los partidos de fútbol colombiano en Fubo. Estos suelen estar disponibles poco después de que terminen los partidos, para que puedas estar al tanto de la acción.',
  },
  {
    question: '¿Qué canal de Fubo transmite la Liga BetPlay Dimayor?',
    answer:
      'El fútbol colombiano, incluyendo los partidos de la Liga BetPlay Dimayor, está disponible en la cadena Fubo Latino y en RCN Nuestra Tele Internacional. Asegúrate de sintonizar los partidos en vivo y la programación relacionada.',
  },
]
